import { render, staticRenderFns } from "./PeopleSearch.vue?vue&type=template&id=46d5ca10"
import script from "./PeopleSearch.vue?vue&type=script&lang=js"
export * from "./PeopleSearch.vue?vue&type=script&lang=js"
import style0 from "./PeopleSearch.vue?vue&type=style&index=0&id=46d5ca10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports